import axios from "fetch-api/fetch-api";
import { IVehicle } from "interfaces/session/IVehicle";
import { IActionResponse } from "../interfaces/base-response";

export function saveItemApi(
  sku: string,
  vehicle: IVehicle,
  customOptions?: {
    customTireSizes?: string[] | null,
    customWheelSizes?: string[] | null,
  },
) {
  const cleanFO = vehicle?.fitmentOptions?.map((fo) => ({
    optionName: fo.optionName,
    optionValue: fo.optionValue,
  }));

  const payload = {
    sku,
    vehicle: cleanFO
      ? { ...vehicle, fitmentOptions: cleanFO }
      : vehicle,
    ...Object.fromEntries(
      Object.entries(customOptions || {}).filter(
        ([_, value]) => Array.isArray(value) && value.length,
      ),
    ),
  };

  return axios.post<IActionResponse>("/save-item", payload);
}
